module.exports = __webpack_public_path__ + "img/formulas_old.0284ff40.svg";